import { useEffect, useRef } from 'react';

function isEqual<T>(prevValue: T, currentValue: T) {
  return JSON.stringify(prevValue) === JSON.stringify(currentValue);
}

function usePrevious<T>(value: T) {
  const previousValue = useRef<T>(null);

  useEffect(() => {
    const { current: currentStoredValue } = previousValue || {};

    if (!currentStoredValue || !isEqual(currentStoredValue, value)) {
      previousValue.current = value;
    }
  }, [value]);

  return previousValue.current;
}

export default usePrevious;
